import { FC } from "react";
import { useRef, useState, useEffect, KeyboardEvent } from "react";
import { useAtom, useAtomValue } from "jotai";
import { studyTimeAtom, workDataAtom } from "@/atom/drawBoard";
import { message } from "../Toast";
import cls from "classnames";
import { saveWork, WorkInfo } from "@/services/api";
import styles from "./index.module.scss";
import { Tooltip } from "antd";

const LeftPanelWorkName: FC<any> = ({
  workId,
  name,
  editor,
  setEditor,
}: any) => {
  const [newName, setNewName] = useState("");
  const [workData, setWorkData] = useAtom(workDataAtom);
  const studyTime = useAtomValue(studyTimeAtom);

  const refInput = useRef<HTMLInputElement>(null);
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const saveName = async () => {
    let result = await saveWork({
      workId: workId,
      workName: newName,
      situation: { timer: studyTime },
    });

    if (result.code === 0) {
      refInput.current?.blur();
      message.info("作品名称修改成功", 3000);
      setEditor(false);
    }
  };

  const onFocus = () => {
    if (newName === "未命名作品") {
      refInput.current!.select();
    }
  };

  const handleSave = () => {
    if (!newName) {
      message.info("作品名称不能为空", 3000);
      return;
    }
    if (newName !== name) {
      saveName();
      if (workId === workData?.workId)
        setWorkData((prev: any) => {
          return {
            ...prev,
            workName: newName,
          } as WorkInfo;
        });
    } else {
      setEditor(false);
    }
  };

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event?.keyCode === 13 || event?.keyCode === 14 || event?.keyCode === 16 || event?.keyCode === 17) {
      handleSave();
      refInput.current?.blur();
    }
  };

  useEffect(() => {
    if (name) {
      setNewName(name);
      setEditor(false);
    }
  }, [name]);

  useEffect(() => {
    if (editor) {
      refInput.current?.focus();
    }
  }, [editor]);

  useEffect(() => {
    const span = spanRef.current;
    if (span) {
      setIsOverflow(span.scrollWidth > span.clientWidth);
    }
  }, [newName, name]);

  return (
    <div className={styles.container}>
      {editor ? (
        <div className={styles.inputBox}>
          <input
            type="input"
            ref={refInput}
            className={cls({ [styles.input]: true, [styles.notEdit]: !editor })}
            defaultValue={name}
            maxLength={50}
            value={newName}
            onFocus={onFocus}
            onBlur={handleSave}
            onKeyDown={(event) => onKeyDown(event)}
            onChange={(event) => {
              setNewName(event.target.value.replace(/^\s+|\s+$/g, ""));
            }}
          />
        </div>
      ) : (
        <Tooltip
          title={isOverflow ? (newName ? newName : name) : null}
          placement="top"
        >
          <span
            ref={spanRef}
            className={styles.name}
            style={{
              display: "inline-block",
              // maxWidth: 120,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {newName ? newName : name}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default LeftPanelWorkName;
